import { useEffect, useState } from "react";
import { hasPermission, PERMISSION_CHANGED_EVENT } from "../constants/permissions";

//* ຄືກັບ hasPermission ແຕ່ render ໃໝ່ເມື່ອສິດຖືກໂຫລດໃໝ່ (SideNav ດຶງສິດຫຼັງ mount)
//* ບໍ່ດັ່ງນັ້ນໜ້າທີ່ເປີດຢູ່ຈະໃຊ້ສິດເກົ່າທີ່ cache ໄວ້ຕອນ login ຈົນກວ່າຈະປ່ຽນໜ້າ
export default function usePermission(permission) {
  const [, setVersion] = useState(0);
  useEffect(() => {
    const onChange = () => setVersion((v) => v + 1);
    window.addEventListener(PERMISSION_CHANGED_EVENT, onChange);
    return () => window.removeEventListener(PERMISSION_CHANGED_EVENT, onChange);
  }, []);
  return hasPermission(permission);
}
